<div class="dropdown -parent -multiselect" [class.is-open]="active" (clickOutside)="clickedOutside()">
  <div
    class="-header"
    (click)="toggleState($event)"
    role="button"
    tabindex="0"
    (keydown.enter)="toggleState($event)"
    (keydown.space)="toggleState($event)">
    <span
      class="-button"
      [class.placeholder]="
        (!isHierarchicalData && selectionCount === 0) || (isHierarchicalData && selectedLeafIds.size === 0)
      ">
      {{ buttonTitle }}
      @if (!isHierarchicalData && selectionCount > 0 && showCounts && bigScreen) {
      <span> ({{ selectionCount }}) </span>
      } @if (isHierarchicalData && selectedLeafIds.size > 0 && showHierarchicalCount && bigScreen) {
      <span> ({{ selectedLeafIds.size }}) </span>
      }
    </span>
    <span class="-icon-container" (click)="toggleState($event)">
      <lucide-icon
        class="chevron-icon"
        [class.rotate]="active"
        name="ChevronDown"
        size="18"
        aria-hidden="true"></lucide-icon>
    </span>
  </div>

  @if (active) {
  <div class="-content" [@dropdownMultiselectState]="state" #dropdownFilterOption>
    @if (isHierarchicalData) {
    <div class="content-padding options-scroll">
      @if (tree) {
      <ng-container *ngTemplateOutlet="hierNodeTpl; context: { $implicit: tree, depth: 0 }"></ng-container>
      }
    </div>
    @if (showClearButton) {
    <div
      class="clear-section clear-section-top"
      [class.disabled]="clearDisabled"
      [attr.aria-disabled]="clearDisabled"
      (click)="onClearClick($event)">
      Clear
    </div>
    } } @else {
    <div class="content-padding" [class.options-scroll]="shouldScroll">
      @for (content of dropdownContent; track content) {
      <div class="-content-option">
        <label class="-group-element">
          <input
            type="checkbox"
            [value]="content.name"
            [checked]="content.checked"
            (change)="onOptionChange(content, $event)" />
          <span class="-checkbox-container">
            <span class="-group-element-checkbox -checkbox-blue"></span>
          </span>
          <span class="-checkbox-text">
            {{ content.name }}
            @if (showCounts) {
            <span class="content-count">({{ content.count }})</span>
            }
          </span>
        </label>
      </div>
      }
    </div>
    @if (showClearButton) {
    <div
      class="clear-section clear-section-top"
      [class.disabled]="clearDisabled"
      [attr.aria-disabled]="clearDisabled"
      (click)="onClearClick($event)">
      Clear
    </div>
    } }
  </div>
  }
</div>

<ng-template #hierNodeTpl let-node let-depth="depth">
  @if (node && node.id !== ROOT_ID) {
  <div class="-content-option">
    <label class="-group-element depth-{{ depth }}">
      <input
        type="checkbox"
        [checked]="isNodeChecked(node)"
        [indeterminate]="isNodeIndeterminate(node)"
        (change)="onHierarchicalToggle(node, $event)" />
      <span class="-checkbox-text" [innerHTML]="node.labelHtml"></span>
    </label>
  </div>
  } @if (node.children) {
  <div>
    @for (child of node.children; track child) {
    <ng-container *ngTemplateOutlet="hierNodeTpl; context: { $implicit: child, depth: depth + 1 }"></ng-container>
    }
  </div>
  }
</ng-template>
